import React from "react"
import { useTranslation } from "react-i18next"
import "./Modal.css"

export interface ModalProps {
  heading: string
  children: React.ReactNode
  closeModal: () => void
  submitButtonText?: string
  submitButtonClasses?: string
  onSubmitButtonClicked?: () => void
  submitSpinner?: boolean
  submitDisabled?: boolean
  large?: boolean
  fill?: boolean
}

const Modal = (props: ModalProps) => {
  return (
    <div className="reveal-overlay d-block">
      <div className="reveal-container">
        <div className={`reveal overflow-unset${props.large ? " shared-model-reveal-lg" : ""}`} role="dialog">
          <ModalHeading {...props} />
          <div className={props.fill ? "" : "scroll-section overflow-unset"}>{props.children}</div>
          <ModalFooter {...props} />
        </div>
      </div>
    </div>
  )
}

const ModalHeading = (props: ModalProps) => (
  <header className="align-items-start">
    <div>
      <h2>{props.heading}</h2>
    </div>
    <button type="button" className="button icon-circle icon-medium tertiary" onClick={props.closeModal}>
      <i className="icon-font tc-icon-content-close"></i>
    </button>
  </header>
)

const ModalFooter = (props: ModalProps) => {
  const { closeModal, submitButtonText, submitButtonClasses, onSubmitButtonClicked } = props
  const classes = submitButtonClasses || "primary"
  const { t } = useTranslation("common")

  return (
    <footer>
      {submitButtonText && onSubmitButtonClicked && (
        <div>
          <hr />
          <div className="wrap-buttons">
            <button className="button link-secondary" onClick={closeModal} data-testid="quadri-modal-close">
              {t("cancel")}
            </button>
            <button
              className={`button ${classes}`}
              disabled={props.submitDisabled}
              onClick={onSubmitButtonClicked}
              data-testid="quadri-modal-save"
            >
              {props.submitSpinner && <i className="icon-font tc-icon-spinner-light"></i>}
              {submitButtonText}
            </button>
          </div>
        </div>
      )}
    </footer>
  )
}

export default Modal
